<template>
    <div>
        <v-list-item @click="lectureAction()" v-ripple="phoneOnly" :class="{'px-1 mx-3': phoneOnly, 'px-3': pcOnly, 'appbg': lecture.expired && phoneOnly}" :disabled="locked" :style="locked ? `opacity: 0.5` : ''">
            <v-list-item-icon class="my-auto">
                <v-avatar size="50" :color="isDark ? 'surface2' : color" style="border-radius: 6px">
                    <v-progress-circular v-if="loading" color="white" indeterminate :size="23" :width="3" style="opacity: 0.6"></v-progress-circular>
                    <v-icon v-else-if="pay_type === 'course'" :color="isDark ? color : 'white'">mdi-{{lecture.purchased ? 'play-circle' : (lecture.preview ? 'play-speed' : 'play-circle-outline')}}</v-icon>
                    <v-icon :color="isDark ? color : 'white'" v-else>mdi-{{lecture.purchased ? 'motion-play' : 'clipboard-play-outline'}}</v-icon>
                </v-avatar>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title class="strong-text--text">{{lecture.name}}</v-list-item-title>
                <v-list-item-subtitle v-if="pay_type === 'course'">
                    <span v-if="lecture.expired" class="error--text">منتهية الصلاحية</span>
                    <span v-else-if="lecture.purchased">اضغط لعرض محتويات المحاضرة</span>
                    <span v-else-if="lecture.preview">اضغط لمعاينة المحاضرة</span>
                    <span v-else>احصل على الدورة لعرض المحاضرة</span>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else>
                    <template v-if="!lecture.purchased">
                        <span v-if="free">احصل عليها اﻵن</span>
                        <span v-else>{{moneyFormat(lecture.price, true)}}</span>
                    </template>
                    <div v-else class="d-flex ">
                        <span class="details-text">
                            <span v-if="lecture.expired" class="error--text">منتهية الصلاحية</span>
                            <span v-else-if="free">اضغط لعرض المحاضرة</span> 
                            <span v-else>تم الشراء</span> 
                            <template v-if="lecture.repurchasable">
                                | 
                                <v-btn color="strong-text" text small class="px-1" style="height: auto" @click.stop="purchaseDialog=true" @touchstart.stop @mousedown.stop>
                                    {{free ? 'احصل عليها ' : 'شراء '}}
                                     مرة أخرى؟
                                </v-btn>
                            </template>
                        </span>
                    </div>
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon class="my-auto">
                <v-icon v-if="pay_type === 'course'" :color="lecture.preview && !lecture.purchased ? (isDark ? 'deep-purple' : 'deep-purple accent-4') : ''">mdi-{{locked ? 'shield-lock-outline' : (lecture.preview && !lecture.purchased ? 'shield-lock-open-outline' : 'chevron-left')}}</v-icon>
                <v-icon v-else :color="free ? (isDark ? 'deep-purple' : 'deep-purple accent-4') : ''">mdi-{{lecture.purchased ? 'chevron-left' : (free ? 'star-four-points-outline' : 'credit-card-plus-outline')}}</v-icon>
            </v-list-item-icon>
        </v-list-item>
        
        <lecture-purchase-dialog v-if="pay_type !== 'course'" v-model="purchaseDialog" :lecture="lecture" :free="free" @purchased="sync" />

        <lecture-dialog v-if="hasAccess" v-model="videosDialog" :pay_type="pay_type" :lecture="lecture" :videos="videos" :exams="exams" :attachments="attachments" />
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import LecturePurchaseDialog from '@/components/custom/lecture-purchase-dialog'
import LectureDialog from './lecture-dialog'

export default {
    props: {
        lecture: {},
        pay_type: {},
    },
    components: {LecturePurchaseDialog, LectureDialog},
    data(){
        return {
            purchaseDialog: false,
            videosDialog: false,

            videos: null,
            exams: null,
            attachments: null,
            loading: false,
        }
    },
    computed: {
        ...GlobalComputed,
        free(){
            return this.lecture.free || this.lecture.price === 0;
        },
        locked(){
            return this.pay_type === 'course' && !this.lecture.preview && !this.lecture.purchased;
        },
        hasAccess(){
            if (this.pay_type === 'course'){
                return this.lecture.purchased || this.lecture.preview;
            }else{
                return this.lecture.purchased;
            }
        },
        color(){
            let color = '';
            if (this.pay_type === 'course'){
                color = this.locked ? 'strong-text darken-4' : (this.lecture.preview ? (this.isDark ? 'deep-purple' : 'deep-purple accent-4') : 'primary');
            }else{
                color = this.lecture.purchased ? 'secondary' : 'primary';
            }
            return color;
        }
    },
    methods: {
        ...GlobalMethods,
        sync(lecture){
            this.$emit('sync', lecture);
        },
        lectureAction(){
            const lecture = this.lecture;
            if (this.hasAccess){
                this.showVideos();
            }else{
                this.purchaseDialog = true;
            }
        },
        showVideos(){
            this.loadLectureContents();
        },
        loadLectureContents(){
            if (!this.loading){
                this.loading = true;
                window.axios.get(`/lectures/${this.lecture.id}/contents`).then(response=>{
                    this.loading = false;
                    this.videos = response.data.videos;
                    this.exams = response.data.exams;
                    this.attachments = response.data.attachments;
                    this.videosDialog = true;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء جلب الفيديوهات', 'error');
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.course-card.v-card{
    transition: 0.1s ease all;
    border-radius: 6px!important;
    overflow: hidden;
    box-shadow: 1px 2px 4px rgba(0,0,0, .1)!important;
    &:hover{
        // box-shadow: 1px 3px 9px 2px rgba(0,0,0, .1)!important;
    }
}
